  export const Constants = {
  deletedMessage: {
    text: 'This message was deleted.',
    icon: 'slash-line',
  },
  forwardedMessage: {
    maxSelectedChannels: 3,
    maxSelectedMessages: 20,
  },
  poll: {
    icon: 'menu-03',
    maxOptions: 12,
  },
  // @spec FR-0077@v1 — Quick Reply.
  quickReply: {
    // @spec BR-0029@v1 — preview text limit.
    previewTextLimit: 100,
  },
  reminder: {
    // GetStream rejects remind_at less than 60s ahead ("remind_at must be at
    // least one minute in the future"). We require 2 minutes so the value stays
    // safely above that hard server floor after the in-flight queryReminders /
    // getDevices round-trips and any client/server clock skew, and it matches
    // the 2-minute minimum the date/time pickers already enforce in the UI.
    minLeadTimeMs: 2 * 60 * 1000,
    tooSoonMessage: 'Please pick a reminder time at least 2 minutes from now.',
  },
  maxTimeBetweenGroupedMessages: 60000, // 1 minute in milliseconds
  maxSelectedMembers: 99,
  maxImageSize: 20000000, // 20MB in bytes
  maxMembersGroup: 1000,
  maxReactionsToShow: 3,
  messageStatus: {
    read: {
      color: 'color:primarySolid500',
    },
     delivered: {
      color: 'color:neutralSolid500',
    },
  },
  maxMentions: 50
}

